import React from 'react'
import {useToggle} from '@startlibs/core'
import {TextInput} from '@startlibs/form'
import {Icon} from '@startlibs/components'
import styled from 'styled-components'

export const PasswordVisibilityButton = styled(Icon) `
  position: absolute;
  right: 1rem;
  bottom: 5px;
  font-size: 24px;
  color: rgba(0,0,0,0.5);
  cursor: pointer;
  :hover {
    color: rgba(0,0,0,0.75);
  }
`

const Container = styled.div`position:relative;`

export const PasswordInput = (({syncVisible,...props}) => {
  const visible = useToggle()
  const finalVisible = syncVisible || visible
  return <Container>
    <TextInput
      {...props}
      type={finalVisible.isOpen ? 'text' : "password"}
    />
    <PasswordVisibilityButton onClick={(e) => { finalVisible.toggle(); e.target.parentNode.querySelector('input').focus()}} icon={finalVisible.isOpen ? "hide" : "view"}/>
  </Container>
})